module.exports = __webpack_public_path__ + "img/browsers-differences.90954043.png";